var _style, _defs, _defs2, _rect, _defs3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 839.5 589.9",
    style: {
      enableBackground: "new 0 0 839.5 589.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000103243377514719167880000017406400288765506709_);}\r\n\t.st1{clip-path:url(#SVGID_00000111191582611352394980000000405100149618293691_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{clip-path:url(#SVGID_00000071556167841586939860000013227143803992832903_);}\r\n\t.st4{opacity:0.1;fill:#B5394A;enable-background:new    ;}\r\n\t.st5{opacity:0.1;fill:#B8850F;enable-background:new    ;}\r\n\t.st6{opacity:0.1;fill:#0F2B47;enable-background:new    ;}\r\n\t.st7{opacity:0.1;fill:#EA4F5F;enable-background:new    ;}\r\n\t.st8{opacity:0.1;fill:#FAB31A;enable-background:new    ;}\r\n\t.st9{opacity:0.1;fill:#004972;enable-background:new    ;}\r\n\t.st10{opacity:0.1;fill:#008D89;enable-background:new    ;}\r\n\t.st11{opacity:0.1;fill:#00ACA7;enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 839.5,
    height: 589.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018926813361990877380000011365831650750382250_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018926813361990877380000011365831650750382250_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000004518522148290293920000004534077758055300230_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075148520435538965060000003314401485572885424_",
    x: -106.6,
    y: -77.2,
    width: 1052.6,
    height: 744.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085968255938174800240000007184295576500197039_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075148520435538965060000003314401485572885424_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000085968255938174800240000007184295576500197039_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -106.6,
    y: -77.2,
    className: "st2",
    width: 1052.6,
    height: 744.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000172415994677801320120000010043640253662631082_",
    x: -106.6,
    y: -77.2,
    width: 1052.6,
    height: 744.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005985540599217759810000015228625960970439596_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172415994677801320120000010043640253662631082_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005985540599217759810000015228625960970439596_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "341.7,513.6 542,513.6 641.9,667.5 341.7,667.5  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "194.9,204.7 195.5,391.9 195.5,391.9 -134.6,525.3 -109.6,667.6 196,667.6 -162.2,670.2  -142.7,206  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "644.5,385.2 644.5,198.1 644.5,198.1 951.8,76.2 951.7,-68.6 969.2,-68.6 984.8,385.2  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "644.5,671.6 542,513.4 644.5,415.4 945.7,415.4 945.7,671.7  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "-134.6,525.3 195.5,391.9 311.4,513.6 311.4,667.6 -109.6,667.6  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "951.8,76.2 644.5,198.1 534.2,76.2 534.2,-77.7 951.7,-77.7  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "503.8,76.2 293.3,76.2 293.3,76.2 195.9,-77.7 503.8,-77.7  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "194.9,-79.2 293.3,76.2 194.9,174.4 -106.2,174.4 -106.2,-78.3  "
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg3);
export default __webpack_public_path__ + "static/media/bg3.0664b97ff396ff8a81c87e77c095615d.svg";
export { ForwardRef as ReactComponent };